module.exports = __webpack_public_path__ + "img/arrow_right.e2663b68.svg";